import type { WorkPeriodNode } from '../types.graphql'
import { useTranslate } from '@ur-solutions/react-hooks'
import { TextAndAction } from './TextAndAction'
import { GenerationTraceTooltip } from './generation-trace-tooltip'
import { formatPartOfDay } from './part-of-day'
import type { DriverDietFields } from './use-edit-driver-diet'
import { useEditDriverDiet } from './use-edit-driver-diet'

export const DietButton: React.FC<{
  workPeriod?: Pick<WorkPeriodNode, 'id' | 'driverDiet'>
  /**
   * Award the diet to the rest after a shift instead of to the shift. Exactly
   * one of `workPeriod` and `restPeriod` is set; a diet has one subject.
   */
  restPeriod?: {
    id: string
    driverDiet?: DriverDietFields | null
    /** Nights the rest covers; the diet may be worth one per night. */
    nights?: number
  }
  userId: string
  canEdit?: boolean
  border?: boolean
  restrictWidth?: boolean
  onChange?: () => void
}> = ({
  workPeriod,
  restPeriod,
  userId,
  canEdit,
  border,
  restrictWidth,
  onChange,
}) => {
  const driverDiet = restPeriod ? restPeriod.driverDiet : workPeriod?.driverDiet
  const translations = useTranslate({
    diet: 'common.diet',
  })
  const editDriverDiet = useEditDriverDiet(userId, onChange)

  return (
    <TextAndAction
      text={translations.diet}
      info={<GenerationTraceTooltip trace={driverDiet?.generationTrace} />}
      actionText={
        driverDiet?.salaryCode && (driverDiet.partOfDay ?? 0) > 0
          ? `${formatPartOfDay(driverDiet.partOfDay ?? 0)} ${
              driverDiet.salaryCode.name
            }`
          : undefined
      }
      border={border}
      disabled={!canEdit}
      onClick={
        canEdit
          ? () =>
              void editDriverDiet({
                workPeriodId: workPeriod?.id ?? null,
                restPeriodId: restPeriod?.id ?? null,
                maxPartOfDay: restPeriod?.nights ?? 1,
                driverDiet,
              })
          : () => {}
      }
      restrictWidth={restrictWidth}
    />
  )
}
